import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function fetchAssignments(examinerId) {
  return axiosInstance.get(`${BASE_URL}/api/assignments/${examinerId}`);
}

export function addAssignment(examinerId, groupId, juryId) {
  return axiosInstance.post(`${BASE_URL}/api/assignments`, {
    id_examiner: examinerId,
    id_batch: groupId,
    id_jury: juryId,
  });
}

export function deleteAssignment(examinerId, groupId, juryId) {
  return axiosInstance.delete(`${BASE_URL}/api/assignments`, {
    data: { id_examiner: examinerId, id_batch: groupId, id_jury: juryId },
  });
}
